import { DealPropsSchema } from '../../graph-schemas/pevc-dealflow';
import type { NodeDefinition } from './base-crm';

export const PEVC_DEALFLOW_NODES: Record<string, NodeDefinition> = {
  Deal: {
    type: 'Deal',
    schema: DealPropsSchema,
    displayName: 'Deal',
    displayNamePlural: 'Deals',
    icon: 'Handshake',
    color: '#f59e0b',
    description: 'Investment opportunities in companies that you are evaluating for potential investment',
    synonyms: ['deal flow', 'investment opportunity', 'prospect company', 'target company', 'potential investment'],
    formFields: [
      { key: 'name', label: 'Name', type: 'text', required: true },
      { key: 'stage', label: 'Stage', type: 'select', required: true, picklistName: 'deal_stage' },
      { key: 'deal_type', label: 'Deal Type', type: 'select', picklistName: 'deal_type' },
      { key: 'investment_type', label: 'Investment Type', type: 'select', picklistName: 'investment_type' },
      { key: 'round', label: 'Round', type: 'select', picklistName: 'deal_round' },
      { key: 'target_investment', label: 'Target Investment', type: 'number', format: 'currency' },
      { key: 'proposed_valuation', label: 'Proposed Valuation', type: 'number', format: 'currency' },
      { key: 'expected_close_date', label: 'Expected Close', type: 'date' },
      { key: 'source', label: 'Source', type: 'select', picklistName: 'deal_source' },
      { key: 'source_detail', label: 'Source Detail', type: 'text' },
      { key: 'owner_user_id', label: 'Owner', type: 'user' },
    ],
    pmnEnabled: true,
    relationshipSections: [
      {
        sectionLabel: 'Company',
        icon: 'Building2',
        edgeTypes: ['DEAL_FOR'],
        direction: 'outgoing',
        renderMode: 'grid',
        columns: [
          { field: 'name', headerName: 'Company', flex: 2, minWidth: 150, source: 'node', editable: false },
          { field: 'industry', headerName: 'Industry', flex: 1, minWidth: 120, source: 'node', editable: false },
        ],
      },
      {
        sectionLabel: 'Vehicle',
        icon: 'Landmark',
        edgeTypes: ['INVESTING_FROM'],
        direction: 'outgoing',
        renderMode: 'grid',
        columns: [
          { field: 'name', headerName: 'Vehicle', flex: 2, minWidth: 150, source: 'node', editable: false },
          { field: 'status', headerName: 'Status', width: 120, source: 'node', editable: false },
        ],
      },
      {
        sectionLabel: 'Investment',
        icon: 'TrendingUp',
        edgeTypes: ['ORIGINATED_FROM'],
        direction: 'incoming',
        renderMode: 'grid',
        columns: [
          { field: 'name', headerName: 'Investment', flex: 2, minWidth: 150, source: 'node', editable: false },
          { field: 'invested_amount', headerName: 'Amount', width: 120, type: 'number', format: 'currency', source: 'node', editable: false },
        ],
      },
    ],
  },
};
